export default __webpack_public_path__ + "static/media/ico_app.f8ebb234.svg";